export default "__VITE_ASSET__caGfu7oO__"